import { toastr } from 'react-redux-toastr';
import { reset as resetForm, initialize } from 'redux-form';
import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';

export function setModoTela(modo) {
    return {
        type: 'LOGIN_MODO_TELA',
        payload: {
			modo: modo
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('authForm', registro)
    ];
}

export function esqueciSenha(registro) {
	return (dispatch, getState) => {
		axios.post(`${consts.OAPI_URL}/usuario/esquecisenha`, { ...registro })
		.then(resp => {
			dispatch(setModoTela('redefinirSenha'));
			dispatch(initForm({
				...registro,
				senha: '',
				senha_confirmacao: ''
			}));
			dispatch([{
				type: 'USER_MESSEGE',
				payload: {
					open: true,
					text: 'Enviamos um código para seu e-mail',
					time: 5000,
					type: 'success'
				}
			}]);
		})
		.catch(e => {
			dispatch([{
				type: 'USER_MESSEGE',
				payload: {
					open: true,
					text: setToastAPI(e),
					time: 5000,
					type: 'error'
				}
			}]);
		})
	}
}

export function redefinirsenha(registro) {
	return (dispatch, getState) => {
		axios.post(`${consts.OAPI_URL}/usuario/redefinirsenha`, { ...registro })
		.then(resp => {
			dispatch(setModoTela('login'));
			dispatch(initForm({
				...registro,
				senha: '',
				senha_confirmacao: ''
			}));
			dispatch([{
				type: 'USER_MESSEGE',
				payload: {
					open: true,
					text: 'Senha redefinida com sucesso!!',
					time: 5000,
					type: 'success'
				}
			}]);
		})
		.catch(e => {
			dispatch([{
				type: 'USER_MESSEGE',
				payload: {
					open: true,
					text: setToastAPI(e),
					time: 5000,
					type: 'error'
				}
			}]);
		});
	}
}

export function setToastAPI(e) {
	if (e.response.status == 400) {		
		if (e.response.data instanceof Array) {
			let mensagem = '';
			e.response.data.forEach(retorno => {
				mensagem = retorno.msg ? retorno.msg : retorno;
			});
			return mensagem;
		} else {
			return e.response.data;
		}
	} else {
		return 'Erro ao realizar Operação!!';
	}
}

export function login(values) {
	return submit(values, `${consts.OAPI_URL}/usuario/login`);
}

export function signup(values) {
	return submit(values, `${consts.OAPI_URL}/signup`);
}

function submit(values, url) {
	return dispatch => {
		axios.post(url, values)
		.then(resp => {
			dispatch([
				{type: 'USER_FETCHED', payload: resp.data}
			]);
		})
		.catch(e => {
			console.log(e);
			if (e.response.status == 400) {
				if (e.response.data instanceof Array) {
					e.response.data.forEach(retorno => {
						dispatch([{
							type: 'USER_MESSEGE',
							payload: {
								open: true,
								text: retorno.msg ? retorno.msg : retorno,
								time: 5000,
								type: 'error'
							}
						}]);
						setTimeout(() => {
							dispatch([{
								type: 'USER_MESSEGE',
								payload: {
									open: false,
									text: '',
									time: 5000,
									type: 'error'
								}
							}]);
						}, 6000);
					});
				} else {
					dispatch([{
						type: 'USER_MESSEGE',
						payload: {
							open: true,
							text: e.response.data,
							time: 5000,
							type: 'error'
						}
					}]);
					setTimeout(() => {
						dispatch([{
							type: 'USER_MESSEGE',
							payload: {
								open: false,
								text: '',
								time: 5000,
								type: 'error'
							}
						}]);
					}, 6000);
				}
			} else {
				dispatch([{
					type: 'USER_MESSEGE',
					payload: {
						open: true,
						text: 'Erro ao realizar Operação!!',
						time: 5000,
						type: 'error'
					}
				}]);
				setTimeout(() => {
					dispatch([{
						type: 'USER_MESSEGE',
						payload: {
							open: false,
							text: '',
							time: 5000,
							type: 'error'
						}
					}]);
				}, 6000);
			}
		});
	}
}

export function alterarSenha(registro) {
    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/usuario/alterarsenha`, {
			...registro
		}).then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(carregarUsuario());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function alterarSenhaConfirmacao(registro, evento) {
    return (dispatch, getState) => {
		axios.post(`${consts.API_URL}/usuario/alterarsenha`, {
			...registro,
			valida_atual: true
		}).then(resp => {
			setSuccess('Senha alterada com sucesso.');

			if (evento) {
				evento();
			}
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function logout() {
	return {type: 'TOKEN_VALIDATED', payload: false};
}

export function validateToken(token) {
	return dispatch => {
		if (token) {
			axios.post(`${consts.OAPI_URL}/usuario/validateToken`, {token})
			.then(resp => {
				dispatch({type: 'TOKEN_VALIDATED', payload: resp.data.valid})
			})
			.catch(e => dispatch({type: 'TOKEN_VALIDATED', payload: false}))
		} else {
			dispatch({type: 'TOKEN_VALIDATED', payload: false});
		}
	}
}

export function setCliente(id_cliente) {
	return {
		type: 'USER_CLIENTE_SELECIONADO',
		payload: id_cliente
	};
}

export function carregarUsuario(token) {
	return (dispatch, getState) => {
		
		
		if (!axios.defaults.headers.common['authorization'] && token) { 
			axios.defaults.headers.common['authorization'] = token;
		}

		axios.get(`${consts.API_URL}/usuario/carregar?id=${getState().auth.usuario ? getState().auth.usuario.id : 0}`)
		.then(resp => {
			dispatch({
				type: 'USER_CARREGADO',
				payload: resp
			});
		})
		.catch(e => {
			console.log(e);
		});
	}
}

export function buscarPermissao(rota) {
	return async (dispatch, getState) => {
		
		try {
			let liberado = null;
			getState().menuPerfilAcesso.listaMenu.forEach(modulo => {

				if (modulo.liberado) {
					
					const telaAcesso =  (modulo.telas || []).filter(tela => tela && tela.liberado && tela.rota && tela.rota == rota)[0];

					if (telaAcesso) {
						liberado = telaAcesso;
					}
				}
			});

			return liberado;
							
		} catch(e) {
			console.log(e);
			return null
		}
	};
}

export function buscarImagemLogin() {
	return async (dispatch, getState) => {

		axios.get(`${consts.OAPI_URL}/configImagemLogin/buscarImagemAtual`)
		.then(resp => {
			dispatch({
				type: 'USER_IMAGEM_LOGIN_CARREGADA',
				payload: resp.data
			});
		})
		.catch(e => {
			console.log(e);
		});
	};
}

// FAVORITOS
export function salvarFavoritos(registro) {
    return (dispatch, getState) => {
	    axios.post(`${consts.API_URL}/usuario/favoritos`, {
			...registro,
			id: getState().auth.usuario.id
		}).then(resp => {			
			dispatch({
				type: 'USER_FAVORITOS_CARREGADO',
				payload: {
					data: {
						...getState().auth.favoritos,
						...registro
					}
				}
			});
		}).catch(e => {
			setErroAPI(e);
		});
    };
}